import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on } from '../modules/events.js'
import Isotope from 'isotope-layout'
import GLightbox from 'glightbox'

class RoomsSection extends Section {
  initState() {
    return {
      filterId: -1
    }
  }

  init() {
    this.computed(() => this.filterIdChanged(this.state.filterId))
    this.isotopeSetup()
    this.lightboxSetup()
  }

  lightboxSetup() {
    if (!this.refs.images?.length) {
      return
    }

    this.refs.images.forEach((el, i) => {
      on(el, 'pointerup', () => {
        const elements = this.lightboxImages()
        const gallery = GLightbox({
          elements,
          startAt: i
        })
        gallery.open()
      })
    })
  }

  lightboxImages() {
    if (!this.refs.images?.length) {
      return
    }

    const items = []
    this.refs.images.forEach((el) => {
      const source = el.querySelector('source:last-of-type')
      if (source) {
        items.push({
          href: source.src,
          type: 'image'
        })
      }
    })
    return items
  }

  isotopeSetup() {
    if (!this.refs.grid) {
      return
    }

    this.grid = new Isotope(
      this.refs.grid,
      {
        itemSelector: 'picture',
        layoutMode: 'fitRows',
        fitRows: {
          gutter: '.rooms-images-gutter'
        }
      }
    )

    if (this.refs?.filters?.length) {
      this.refs.filters.forEach((el) => {
        on(el, 'pointerup', () => {
          this.state.filterId = (this.state.filterId === el.dataset.id) ? -1 : el.dataset.id
        })
      })
    }
  }

  filterIdChanged(value) {
    this.isotopeFilter(value)
    this.refs.filters.forEach((el, i) => {
      el.dataset.active = (i === value) ? 1 : 0
    })
  }

  isotopeFilter(id) {
    if (id && this.grid) {
      if (id === -1) {
        this.grid.arrange({ filter: 'picture' })
      }
      else {
        this.grid.arrange({ filter: `[data-filter="${id}"]` })
      }
    }

    this.refs.filters.forEach((el) => {
      el.dataset.current = el.dataset.id == id ? 1 : 0
    })
  }
}

register('rooms', RoomsSection)
